import { ErrorBoundary } from 'react-error-boundary';
import { useSelector } from 'react-redux';
import { ErrorFallback } from '../components/ErrorFallback/ErrorFallback';
import BorrowerLoans from '../components/Loan/Loans/BorrowerLoans';
import InvestorLoans from '../components/Loan/Loans/InvestorLoans';
import { UserTypeId } from '../helpers/constants';
import { RootState } from '../states/reducers';

const LoansPage = () => {
  const { auth } = useSelector((state: RootState) => state);
  const userTypeId = auth.authUser?.user.user_type_id;

  const Loans = userTypeId === UserTypeId.INVESTOR ? InvestorLoans : BorrowerLoans;

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Loans />
    </ErrorBoundary>
  );
};

export default LoansPage;
